export default __webpack_public_path__ + "static/media/src2_melodyne.7a9b779e.mp3";